import config from "@Config/index";
import axios from "axios";
import { logger } from "helpers/logger";
import urlJoin from "helpers/urljoin";

const getNominatedSearchProperties = async (
  canonicalName: string,
  userLanguage = "en",
  userCurrency = "",
) => {
  try {
    const url = urlJoin(config.API_URL, "api/v1/inventories");
    const res: any = await axios.get(url, {
      params: {
        p: 1,
        limit: 10,
        only: "id,name,parent_id,pricing,images,videos,location,canonical_name,tags,features,source_link",
        sort_key: "relevance_sorting_v2",
        region_radius: 20000,
        region_type: "circle",
        use_open_search: true,
        sort_order: "desc",
        statuses: "active",
        available: true,
        region_canonical_name: canonicalName,
        methods:
          "destination_distances,top_meta_distances, active_children_count,location_coordinates,reviews_count,reviews_rating,meta_short,feature_tags,amber_sales",
        lang: userLanguage,
        ...(userCurrency ? { user_currency: userCurrency } : {}),
        use_java_api: true,
      },
      headers: { "X-Use-Java-Api": "true" },
    });

    let result = [[], "err"];
    if (res.data?.data) {
      result = res.data.data;
    }
    return result;
  } catch (err) {
    logger.log(`Error in getNominatedSearchProperties ${err}`);
    return [[], "err"];
  }
};

export default getNominatedSearchProperties;
